import React from 'react';

import { useParams } from 'react-router-dom';
import SurveyQuestionnairePage from 'screens/Engagement/SurveyQuestionnairePage';
import PreviewAlert from 'screens/admin/common/TemplateCommons/PreviewAlert';

const EngagementTemplatePreview = () => {
  const { templateId } = useParams();
  return (
    <>
      <PreviewAlert />
      <SurveyQuestionnairePage isPreview templateId={templateId} />
    </>
  );
};

export default EngagementTemplatePreview;
